module.exports = __webpack_public_path__ + "static/img/name.0569982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/name.png
// module id = uvqv
// module chunks = 0